module.exports = __webpack_public_path__ + "static/media/train_ticket_2.da47420f.svg";